// Konko: galería de fotos deslizable + tallas (o "Ver") sobre la imagen en las
// tarjetas de colección. Reemplaza a kk-grid-size-swatches.js.
//
// - Galería: el track (.grid-product__gallery) usa scroll nativo con
//   scroll-snap. En mobile eso ya resuelve por sí solo la diferencia entre
//   "deslizar" (el navegador no dispara click en el enlace si el toque movió
//   el scroll) y "tocar sin deslizar" (si no hubo scroll, el enlace navega
//   normalmente al producto). En desktop se avanza con las flechas.
// - Tallas: click/tap navega de inmediato a esa variante (nunca agrega al
//   carrito). Agotadas: deshabilitadas, sin click.
// - Flechas: nunca navegan ni activan el enlace de la tarjeta, solo mueven
//   la galería una foto a la vez; se deshabilitan en el primer/último slide.
(function () {
  'use strict';

  function updateArrows(gallery) {
    var card = gallery.closest('.grid-product');
    if (!card) return;
    var prev = card.querySelector('.grid-product__arrow--prev');
    var next = card.querySelector('.grid-product__arrow--next');
    if (!prev && !next) return;

    var maxScroll = gallery.scrollWidth - gallery.clientWidth;
    if (prev) prev.disabled = gallery.scrollLeft <= 4;
    if (next) next.disabled = gallery.scrollLeft >= maxScroll - 4;
  }

  function goToSlide(gallery, delta) {
    var width = gallery.clientWidth;
    gallery.scrollBy({ left: delta * width, behavior: 'smooth' });
  }

  // Estado inicial de las flechas (scroll:0 => flecha "anterior" deshabilitada).
  function initArrows() {
    document.querySelectorAll('.grid-product__gallery').forEach(updateArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArrows);
  } else {
    initArrows();
  }

  // El evento "scroll" no burbujea, pero sí se propaga en fase de captura:
  // un solo listener delegado alcanza para todas las galerías de la página.
  document.addEventListener(
    'scroll',
    function (event) {
      var gallery = event.target;
      if (gallery && gallery.classList && gallery.classList.contains('grid-product__gallery')) {
        updateArrows(gallery);
      }
    },
    true
  );

  // --- Tarjeta "activa" en mobile/touch ---------------------------------
  // Solo una tarjeta a la vez muestra sus tallas. Se activa al tocar o
  // deslizar su imagen; se desactiva de inmediato al tocar la imagen de
  // otra tarjeta, o al tocar fuera de cualquier imagen de producto.
  var ACTIVE_CLASS = 'kk-gallery-active';
  var activeMask = null;

  function setActiveMask(mask) {
    if (activeMask === mask) return;
    if (activeMask) activeMask.classList.remove(ACTIVE_CLASS);
    activeMask = mask;
    if (activeMask) activeMask.classList.add(ACTIVE_CLASS);
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      var mask = event.target.closest('.grid-product__image-mask');
      setActiveMask(mask);
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      // Flechas de la galería: nunca navegan, solo desplazan.
      var arrow = event.target.closest('.grid-product__arrow');
      if (arrow) {
        event.preventDefault();
        event.stopPropagation();
        if (!arrow.disabled) {
          var mask = arrow.closest('.grid-product__image-mask');
          var gallery = mask && mask.querySelector('.grid-product__gallery');
          if (gallery) {
            goToSlide(gallery, arrow.classList.contains('grid-product__arrow--next') ? 1 : -1);
          }
        }
        return;
      }

      // Tallas (o "Ver"): click/tap navega directo a esa variante/producto.
      var sizeBtn = event.target.closest('.grid-product__size');
      if (sizeBtn) {
        if (sizeBtn.disabled) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        var href = sizeBtn.getAttribute('data-href');
        if (href) {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = href;
        }
        return;
      }

      // Cualquier otro click dentro de la imagen (sin haber deslizado la
      // galería) sigue el enlace normal de la tarjeta (comportamiento nativo
      // del <a class="grid-product__link">): no se necesita JS adicional.
    },
    true
  );
})();
